import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";

@Component({
  selector: "app-house-master",
  templateUrl: "./house-master.component.html",
  styleUrls: ["./house-master.component.css"]
})

export class HouseMasterComponent implements OnInit {
  displayHouseValue: Number = 0;
  houselist: any = [];
  vendorData: any = [];
  submitted = false;
  mode: any = "add";
  housedataFm: FormGroup;
  delID: any = [];

  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;

  noOfItems = 10;

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.getAllData();
    this.getAllVendorData();
  }

  // GET DATA
  getAllData() {
    console.log("GET HOUSE LIST");
    this.awserviceProvider.getHouseList().then(data => {
      this.constructData(data);
      console.log("response", data);
    });
  }

  constructData(data) {
    this.houselist = []
    var oplist = []
    let responseData = data;
    responseData.sort((a, b) => {
      // Handle null/undefined dates
      if (!a.created_date && !b.created_date) return 0;
      if (!a.created_date) return 1; // Put items without dates at the end
      if (!b.created_date) return -1; // Put items without dates at the end

      // Convert dates to timestamps for comparison
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();

      // Handle invalid dates
      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;

      return dateB - dateA; // Descending order (newest first)
    });
    for (var i in responseData) {
      responseData[i].sno = +i + 1;
      oplist.push(responseData[i])
    }
    this.houselist = oplist;
  }

  // ADD DATA
  add() {
    this.displayHouseValue = 1;
    this.mode = "add";
    this.formInitilization();
    console.log("this.housedataFm.value", this.housedataFm.value);
  }

  getAllVendorData() {
    console.log("vendor Data");
    this.awserviceProvider.getActiveVendorlist().then(data => {
      this.vendorData = data.filter(res => res.vendor_type === "Home");
      // this.vendorData = data;
      console.log("vendor-data", this.vendorData);
    });
  }

  formInitilization() {
    // this.housedataFm = new FormGroup({
    //   id: new FormControl(""),
    //   house_address: new FormControl(""),
    //   house_location: new FormControl(""),
    //   house_city: new FormControl(""),
    //   house_type: new FormControl(""),
    //   house_size: new FormControl(""),
    //   // house_exdata: new FormControl(""),
    //   owner_name: new FormControl(""),
    //   owner_email: new FormControl(""),
    //   owner_phone: new FormControl(""),
    //   owner_address: new FormControl(""),
    //   lease_start_date: new FormControl(""),
    //   lease_end_date: new FormControl(""),
    //   property_type: new FormControl(""),
    //   owner_exdata: new FormControl("")
    // });
    this.housedataFm = this.formBuilder.group({
      id: [""],
      house_address: ["", Validators.required],
      house_location: ["", Validators.required],
      house_city: ["", Validators.required],
      house_type: ["", Validators.required],
      house_size: [""],
      owner_name: ["", Validators.required],
      owner_email: ["", [Validators.required, Validators.email]],
      owner_phone: ["", Validators.required],
      owner_address: ["", Validators.required],
      lease_start_date: ["", Validators.required],
      lease_end_date: ["", Validators.required],
      // property_type: ["", Validators.required],
      owner_exdata: ["", [Validators.required, Validators.min(1)]]
    });
  }

  get f() {
    return this.housedataFm.controls;
  }

  // EDIT DATA
  editData(houseDt) {
    console.log("editData", houseDt);
    this.displayHouseValue = 1;
    this.submitted = false;
    this.mode = "edit";
    this.f["id"].setValue(houseDt.id);
    this.f["house_address"].setValue(houseDt.house_address);
    this.f["house_location"].setValue(houseDt.house_location);
    this.f["house_city"].setValue(houseDt.house_city);
    this.f["house_type"].setValue(houseDt.house_type);
    this.f["house_size"].setValue(houseDt.house_size);
    this.f["owner_name"].setValue(houseDt.owner_name);
    this.f["owner_email"].setValue(houseDt.owner_email);
    this.f["owner_phone"].setValue(houseDt.owner_phone);
    this.f["owner_address"].setValue(houseDt.owner_address);
    this.f["lease_start_date"].setValue(houseDt.lease_start_date);
    this.f["lease_end_date"].setValue(houseDt.lease_end_date);
    // this.f["property_type"].setValue(houseDt.property_type);
    this.f["owner_exdata"].setValue(houseDt.owner_exdata);
  }

  // SAVE DATA
  onSubmit() {
    console.log("Add - car data", this.housedataFm.value.id);
    this.submitted = true;
    if (this.housedataFm.invalid) {
      return;
    }
    if (this.housedataFm.value.id !== "") {
      // # UPDATE RECORD #
      this.awserviceProvider
        .UpdateHouseData(this.housedataFm.value)
        .then(result => {
          this.getAllData();
          this.displayHouseValue = 0;
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      // # CREATE RECORD #
      this.awserviceProvider
        .CreateHouseData(this.housedataFm.value)
        .then(result => {
          // console.log('CreateHouseData Result');
          // console.log(result.id);
          this.getAllData();
          this.displayHouseValue = 0;
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }

  deletePopup(house) {
    this.delID = house.id;
  }

  // REFER FROM SC-USER-TRIP - (MASTER)
  deleteData(housedt) {
    console.log("housedt", housedt);
    this.awserviceProvider
      .deleteHouseData(housedt)
      .then(res => {
        this.delID = "";
        this.getAllData();
      })
      .catch(err => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.displayHouseValue = 0;
    this.formInitilization();
    console.log("car data module init");
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }

  }
}
